import React from 'react';
import './AgenticSupport.css';

const PremiumAgenticButton = ({ onClick, label, className = '', style = {} }) => {
    return (
        <button 
            className={`premium-agentic-btn ${className}`} 
            onClick={onClick}
            style={style}
        >
            <div className="premium-agentic-btn-glow"></div>
            <img src="/img/agentic-ai.png" alt="AI" className="premium-agentic-btn-icon" />
            <span className="premium-agentic-btn-text">{label}</span>
        </button>
    );
};

export default PremiumAgenticButton;
